import React, { useContext, useEffect, useState } from 'react'
import TabPanel from './TabPanel'
import MarketingComplianceTable from './MarketingComplianceTable'
import { MarktingContext } from '../../Context/MarktingContext';
import BackSection from '../Services/BackSection';

export default function Archived() {
    const { archivedData } = useContext(MarktingContext);

    const [archived, setArchived] = useState(null);
    const [activeTab, setActiveTab] = useState("Awaiting Review");
    const [tableTitel, setTableTitel] = useState("Awaiting Compliance Review");

    useEffect(() => {
        if (archivedData) {
            setArchived(archivedData);


        }
    }, [archivedData]);

    if (!archived) {
        return <p>Loading...</p>;
    }

    return (
        <section>
            <BackSection pageName="Marketing Documents Archive" to={"/setup"} />
                <div className="row align-items-center">
                    <div className="col-md-12">
                        {/* header */}
                        <div className="d-flex align-items-end mb-2 justify-content-between">
                            {/* <h4 className="title ">Marketing Documents Archive</h4> */}
                        </div>
                        {/* body */}
                        <ul className="tabsContainer">
                            <TabPanel
                                setTableTitel={setTableTitel}
                                status="Awaiting Review"
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                                tabName="Awaiting Compliance Review"
                            />
                            <TabPanel
                                setTableTitel={setTableTitel}
                                status="Comments Provided"
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                                tabName="Compliance Comments Provided"
                            />
                            <TabPanel
                                setTableTitel={setTableTitel}
                                status="Adjustments Made"
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                                tabName="Marketing Adjustments Made"
                            />
                            <TabPanel
                                setTableTitel={setTableTitel}
                                status="Active Version"
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                                tabName="Active Version - In Circulation"
                            />
                        </ul>

                        {/* Table (moved outside of the ul) */}
                        <MarketingComplianceTable data={archived} tableTitel={tableTitel} status={activeTab} />
                    </div>
                </div>
        </section>
    )

}
